<template>
   <div class="bg-light pt-3 pb-4">
      <b-container fluid>
         <b-row style="width: 100%">

            <b-col cols="12" lg="3" xl="2" class="p-0">
               <DashUserNav></DashUserNav>
            </b-col>

            <b-col cols="12" lg="9" xl="10" class="pl-3 pl-lg-3 mt-3" style="min-height: 900px;">
               <h5>Nova Bicicleta</h5>

               <!--====== Formulário de Cadastro de Bicicleta ======-->
               <el-steps :active="activeStepBike" finish-status="success" class="mb-2">
                  <el-step title="Informações">
                     <template slot="title">
                        <el-button
                           @click="bikeId ? goTo('info') : null"
                           type="text"
                        >
                           Informações
                        </el-button>
                     </template>
                  </el-step>
                  <el-step title="Disponibilidade">
                     <template slot="title">
                        <el-button
                           :class="{ 'text-primary' : activeStepBike >= 1, 'text-muted' : activeStepBike < 1 }"
                           @click="bikeId ? goTo('disponibilidade') : null"
                           type="text"
                        >
                           Disponibilidade
                        </el-button>
                     </template>
                  </el-step>
                  <el-step title="Características">
                     <template slot="title">
                        <el-button
                           @click="bikeId ?  goTo('caracteristicas') : null"
                           type="text"
                           :class="{ 'text-primary' : activeStepBike >= 2, 'text-muted' : activeStepBike < 2 }"
                        >
                           Caracteristicas
                        </el-button>
                     </template>
                  </el-step>
                  <el-step title="Local de Retirada">
                     <template slot="title">
                        <el-button
                           @click="bikeId ?  goTo('local') : null"
                           type="text"
                           :class="{ 'text-primary' : activeStepBike >= 3, 'text-muted' : activeStepBike < 3 }"
                        >
                           Local de Retirada
                        </el-button>
                     </template>
                  </el-step>
                  <el-step title="Fotos">
                     <template slot="title">
                        <el-button
                           @click="bikeId ?  goTo('fotos') : null"
                           type="text"
                           :class="{ 'text-primary' : activeStepBike >= 4, 'text-muted' : activeStepBike < 4 }"
                        >
                           Fotos
                        </el-button>
                     </template>
                  </el-step>
               </el-steps>

               <!-- ====== ETAPA 1 - Informações ====== -->
               <transition name="fade">
                  <template v-if="activeStepBike === 0">
                     <el-card class="transition-box box-card dashboard-card">
                        <div slot="header" class="clearfix">
                           <span>Informações Gerais</span>
                        </div>

                        <el-form
                           v-loading="loading"
                           :model="bikeForm.info"
                           :rules="bikeFormRules.info"
                           ref="bikeForm.info"
                           class="checkout-form dashboard-form pl-0 pr-0 bikeForm"
                           size="medium"
                        >

                              <el-row :gutter="10">

                                 <!-- Campo nome da bicicleta -->
                                 <el-col :span="24" :lg="12">
                                    <el-form-item :label="`Nome ${bikeTypeData.name}`" prop="name">
                                       <el-input
                                          v-model="bikeForm.info.name"
                                          show-word-limit
                                          maxlength="50"
                                          :placeholder="bikeTypeData.placeholder"/>
                                    </el-form-item>
                                 </el-col>

                                 <!-- Radio seleção do tipo -->
                                 <el-col :span="24" :lg="6">
                                    <el-form-item label="Tipo" prop="type" class="d-flex flex-column">
                                       <v-select
                                          :clearable="false"
                                          :options="bikeTypeList"
                                          v-model="bikeForm.info.bikeType"
                                          :reduce="option => option.value"
                                          placeholder="Selecione..."
                                       />
                                    </el-form-item>
                                 </el-col>

                                 <!-- Campo valor da bicicleta -->
                                 <el-col :span="24" :lg="6">
                                    <el-form-item label="Valor da Bike" prop="bikeValue">
                                       <el-popover
                                          placement="top"
                                          title="Quanto vale a tua bike?"
                                          width="200"
                                          trigger="click"
                                          content="Digite o valor de quanto vale a tua bike. Esse valor será cobrado do ciclista, caso ele não devolva.">
                                          <el-button
                                             slot="reference"
                                             class="help-input-icon"
                                             icon="el-icon-info" circle></el-button>
                                       </el-popover>

                                       <money
                                          :class="'fake-input'"
                                          v-model="bikeForm.info.bikeValue"
                                          v-bind="money">
                                       </money>
                                    </el-form-item>
                                 </el-col>

                              </el-row>

                              <el-row :gutter="10">

                                 <!-- Valor da Hora -->
                                 <el-col :span="24" :lg="6">
                                    <el-form-item label="Valor por hora" prop="timeValue">
                                       <money
                                          :class="'fake-input'"
                                          v-model="bikeForm.info.timeValue"
                                          v-bind="money">
                                       </money>
                                    </el-form-item>
                                 </el-col>

                                 <!-- Valor da Diária -->
                                 <el-col :span="24" :lg="6" >
                                    <el-form-item label="Valor por dia" prop="dailyValue">
                                       <money
                                          :class="'fake-input'"
                                          v-model="bikeForm.info.dailyValue"
                                          v-bind="money">
                                       </money>
                                    </el-form-item>
                                 </el-col>

                                 <!-- Valor por semana -->
                                 <el-col :span="24" :lg="6" >
                                    <el-form-item label="Valor por semana" prop="weekValue">
                                       <money
                                          :class="'fake-input'"
                                          v-model="bikeForm.info.weekValue"
                                          v-bind="money">
                                       </money>
                                    </el-form-item>
                                 </el-col>

                                 <!-- Valor por mês -->
                                 <el-col :span="24" :lg="6" >
                                    <el-form-item label="Valor por mês" prop="monthValue">
                                       <money
                                          :class="'fake-input'"
                                          v-model="bikeForm.info.monthValue"
                                          v-bind="money">
                                       </money>
                                    </el-form-item>
                                 </el-col>

                                 <!-- Informação sobre taxa -->
                                 <el-col v-if="0" :span="24" :lg="6">
                                    <el-form-item label="Taxa" class="mb-0">

                                       <el-button @click="() => {
                                             helpModal.open = true
                                             helpModal.title = 'Taxas Pedale'
                                             helpModal.desc = 'Nao cobramos taxa pelo serviço de locação :). \n'
                                           }"
                                                  class="help-input-icon"
                                                  icon="el-icon-info" circle></el-button>

                                       <span class="fake-input text-muted">ZERO</span>
                                    </el-form-item>
                                 </el-col>

                                 <!-- Campo reativo com o valor atualizado da diária mais taxa -->

                                 <el-col v-if="0"  :span="24" :lg="6">
                                    <el-form-item
                                       :label="daily > 1 ?
                          `Valor Líquido por diária` :
                           `Valor Líquido por Diária`">

                                       <money
                                          :class="'fake-input'"
                                          v-model="bikeForm.info.dailyValue"
                                          v-bind="money"
                                          disabled
                                          style="opacity: 0.6"
                                       >
                                       </money>
                                    </el-form-item>
                                 </el-col>

                              </el-row>

                              <!-- Botão Modal Data de Disponibilidade -->
                              <el-form-item v-if="false">
                                 <el-button
                                    @click="dialogAvailableDates = true"
                                    icon="el-icon-date"
                                    :round="true"
                                    :type="bikeForm.info.availableDates.length ? 'darkblue' : 'blue'"
                                    :class="['', (availableDatesOk === true &&  bikeForm.info.availableDates.length === 0 ? 'btnCalendarError' : '')]"
                                    class="w-100 text-uppercase font-weight-bold mb-4 mt-2">
                                    {{ bikeForm.info.availableDates.length ? 'Editar' : 'Selecionar' }}
                                    datas de disponibilidade
                                 </el-button>
                              </el-form-item>


                           <div class="mb-4 editor">
                              <div class="label">Descrição*</div>
                              <mc-wysiwyg v-model="bikeForm.info.description"></mc-wysiwyg>
                           </div>

                              <!-- Campo Descrição -->
                              <el-form-item label="Descrição" prop="description" class="d-none">
                                 <el-input
                                    v-model="bikeForm.info.description"
                                    type="textarea"
                                    :rows="7"
                                    show-word-limit
                                    maxlength="2048"
                                    placeholder="Faça uma descrição da sua bike. Ex: Esta bike é ótima para um passeio no parque, pois possui amortecedor, banco confortável e ainda conta com 24 marchas e freios de liga leve..."/>
                              </el-form-item>

                              <!-- Form Actions | Ações do formulário -->
                              <b-row>
                                 <!-- Salvar  -->
                                 <b-col v-if="this.bikeId" cols="12" md="4" class="text-center mb-3 mb-md-0">
                                    <el-button
                                       @click="getBikFormInfo('bikeForm.info', true)"
                                       :loading="bikeFormStates.submit.loading"
                                       :round="true"
                                       type="primary"
                                       class="w-100 text-uppercase font-weight-bold">
                                       Salvar
                                    </el-button>
                                 </b-col>

                                 <!-- Próximo -->
                                 <b-col cols="12" md="5" class="text-center mb-3 mb-md-0">
                                    <el-button
                                       @click="getBikFormInfo('bikeForm.info')"
                                       :loading="bikeFormStates.submit.loading"
                                       :round="true"
                                       :type="this.bikeId ? 'blue' : 'primary'"
                                       :plain="!!this.bikeId"
                                       class="w-100 text-uppercase font-weight-bold">
                                       {{ this.bikeId ? 'Editar disponibilidade →' : 'Próximo →' }}
                                    </el-button>
                                 </b-col>

                                 <!-- Cancelar -->
                                 <b-col cols="12" md="3" class="text-center mb-3 mb-md-0">
                                    <el-button
                                       @click="exit()"
                                       type="default"
                                       :round="true"
                                       class="w-100 text-uppercase font-weight-bold">Sair
                                    </el-button>
                                 </b-col>
                              </b-row>

                        </el-form>
                     </el-card>
                  </template>
               </transition>

               <!-- ====== ETAPA 2 - Disponibilidade ====== -->
               <transition name="fade">
                  <SelectAvailableDatesCalendar
                     v-if="activeStepBike === 1" class="transition-box"
                     :bikeForm="bikeForm"
                     :bikeId="bikeId"
                     @dataCalendar="handleGetDataCalendar"
                     @goTo="v => this.goTo(v)"
                  />
               </transition>

               <!-- ====== ETAPA 3 - Caracteristicas ====== -->
               <transition name="fade">
                  <template v-if="activeStepBike === 2">
                     <el-card class="transition-box box-card dashboard-card">
                        <div slot="header" class="clearfix">
                           <span>Características</span>
                        </div>
                        <el-form
                           v-loading="loading"
                           :model="bikeForm.features"
                           :rules="bikeFormRules.features"
                           ref="bikeForm.features"
                           class="checkout-form dashboard-form pl-0 pr-0 bikeForm"
                           size="medium"
                        >

                           <!-- Seleção de Marca -->
                           <el-form-item label="Marca" prop="brand" class="d-flex flex-column">
                              <v-select
                                 :clearable="false"
                                 :options="bikeFeatureList.brand()"
                                 v-model="bikeForm.features.brand"
                                 :reduce="option => option.value"
                                 placeholder="Selecione..."
                              />
                           </el-form-item>

                           <!-- Seleção do Aro -->
                           <el-form-item label="Tamanho do Aro" prop="rim" class="d-flex flex-column">
                              <v-select
                                 :clearable="false"
                                 :options="bikeFeatureList.rim"
                                 v-model="bikeForm.features.rim"
                                 :reduce="option => option.value"
                                 placeholder="Selecione..."
                              />
                           </el-form-item>

                           <!-- Seleção do Quadro -->
                           <el-form-item label="Tamanho do Quadro" prop="frameSize" class="d-flex flex-column">
                              <v-select
                                 :clearable="false"
                                 :options="bikeFeatureList.frameSize()"
                                 v-model="bikeForm.features.frameSize"
                                 :reduce="option => option.value"
                                 placeholder="Selecione..."
                              />
                           </el-form-item>

                           <!-- Seleção de Marchas -->
                           <el-form-item label="Marchas" prop="march" class="d-flex flex-column">
                              <v-select
                                 :clearable="false"
                                 :options="bikeFeatureList.march(33)"
                                 v-model="bikeForm.features.march"
                                 :reduce="option => option.value"
                                 placeholder="Selecione..."
                              />
                           </el-form-item>

                           <!-- Seleção da Suspensão -->
                           <el-form-item label="Suspensão" prop="suspension" class="d-flex flex-column">
                              <v-select
                                 :clearable="false"
                                 :options="bikeFeatureList.suspension"
                                 v-model="bikeForm.features.suspension"
                                 :reduce="option => option.value"
                                 placeholder="Selecione..."
                              />
                           </el-form-item>

                           <!-- Campo Observações -->
                           <el-form-item label="Observações" prop="observation">
                              <el-input
                                 placeholder='Digite algumas obervações, caso tenha. Ex: Proibido empinar ou fazer "Cavalinho de Pau..."'
                                 type="textarea"
                                 :rows="2"
                                 maxlength="250"
                                 show-word-limit
                                 v-model="bikeForm.features.observation"/>
                           </el-form-item>

                           <!-- Form Actions | Ações do formulário -->
                           <b-row>
                              <!-- Salvar  -->
                              <b-col v-if="this.bikeId" cols="12" md="3" class="text-center mb-3 mb-md-0">
                                 <el-button
                                    @click="getBikFormFeatures('bikeForm.features', true)"
                                    :loading="bikeFormStates.submit.loading"
                                    :round="true"
                                    type="primary"
                                    class="w-100 text-uppercase font-weight-bold">
                                    Salvar
                                 </el-button>
                              </b-col>

                              <!-- Próximo -->
                              <b-col cols="12" md="4" class="text-center mb-3 mb-md-0">
                                 <el-button
                                    @click="getBikFormFeatures('bikeForm.features')"
                                    :loading="bikeFormStates.submit.loading"
                                    :round="true"
                                    :type="this.bikeId ? 'blue' : 'primary'"
                                    :plain="!!this.bikeId"
                                    class="w-100 text-uppercase font-weight-bold">
                                    {{ this.bikeId ? 'Editar Local de Retirada →' : 'Próximo →' }}
                                 </el-button>
                              </b-col>

                              <!-- Voltar -->
                              <b-col cols="12" md="3" class="text-center mb-3 mb-md-0">
                                 <el-button
                                    @click="goTo('disponibilidade')"
                                    type="default"
                                    :round="true"
                                    class="w-100 text-uppercase font-weight-bold">Voltar
                                 </el-button>
                              </b-col>

                              <b-col cols="12" md="2" class="text-center">
                                 <el-button
                                    @click="() =>  this.$router.push('/painel/anunciante/minhas-bicicletas')"
                                    type="default"
                                    :round="true"
                                    class="w-100 text-uppercase font-weight-bold">Sair
                                 </el-button>
                              </b-col>
                           </b-row>
                        </el-form>
                     </el-card>
                  </template>
               </transition>

               <!-- ====== ETAPA 4 - Local de Retirada ====== -->
               <transition name="fade">
                  <template v-if="activeStepBike === 3">
                     <el-card class="transition-box box-card dashboard-card">
                        <div slot="header" class="clearfix">
                           <span>Local de Retirada</span>
                        </div>
                        <el-form
                           v-loading="loading"
                           onsubmit="return false;"
                           :model="bikeForm.address"
                           :rules="bikeFormRules.address"
                           ref="bikeForm.address"
                           class="checkout-form dashboard-form pl-0 pr-0 bikeForm"
                           size="medium"
                           label-position="top"
                        >
                           <div class="h-100 position-relative">

                              <el-alert
                                 class="mb-3"
                                 title="ATENÇÃO"
                                 type="info"
                                 description="O local de retirada, é o local aonde o cliente irá BUSCAR e ENTREGAR a bike e não precisa ser necessariamente na sua casa. Você pode escolher um ponto estratégico, como por exemplo, na frente do shopping e deixar a sua bike cadeada (cadeado com código, e você passa o código para o ciclista) por lá. Assim você evita contatos com o cliente ;)"
                                 show-icon>
                              </el-alert>

                              <el-form-item
                                 class="dica-local"
                                 label="Local de Retirada (Você pode arrastar no mapa, o local exato, se quiser!)"
                                 :class="{'is-error' : placeEmpty}">

                                 <el-row :gutter="10">
                                    <el-col :md="21" :sm="19" :xs="20">
                                       <div class="el-input el-input--small">

                                          <gmap-autocomplete
                                             @keyup.enter="enterKeyPlace()"
                                             v-on:blur.native="chackPlaceIsNotEmpaty"
                                             id="inputPlace"
                                             class="el-input__inner"
                                             placeholder="Digite o local de retirada da bicicleta"
                                             @place_changed="setPlace"
                                             ref="places"
                                          >
                                          </gmap-autocomplete>


                                          <div v-show="placeEmpty" class="el-form-item__error"
                                               style="padding: 0 4px !important; margin-top: -6px;">
                                             Escolha o local de retirada!
                                          </div>
                                       </div>
                                    </el-col>

                                    <el-col :md="3" :sm="4" :xs="4">
                                       <el-button style="line-height: 17px;" size="mini"
                                                  @click="clearPlace" class="w-100 pl-0 pr-0" plain
                                                  icon="el-icon-close" title="Limpar"></el-button>
                                    </el-col>
                                 </el-row>

                                 <span
                                    style="color: rgb(192, 196, 204);position: absolute;left: 0;bottom: -24px;"
                                    class="small">{{
                                       gMap.coordinates === null ? '' : `Latitude: ${bikeForm.location[1]}, Longitude: ${bikeForm.location[0]}`
                                    }}</span>
                              </el-form-item>

                              <GmapMap
                                 class="gmap-location"
                                 :center="{ lat: (!bikeForm.location.coordinates[1] ? gMap.startPlace.lat : bikeForm.location.coordinates[1]), lng: (!bikeForm.location.coordinates[0] ? gMap.startPlace.lng : bikeForm.location.coordinates[0]) }"
                                 :zoom="gMap.zoomMap"
                                 map-type-id="roadmap"
                                 style="width: 100%; height: 370px"
                                 :options="gMap.options">

                                 <GmapMarker
                                    :clickable="true"
                                    :draggable="true"
                                    @dragend="updateCoordinates"
                                    @click="center = bikeForm.location"
                                    :position="{ lat: (!bikeForm.location.coordinates[1] ? gMap.startPlace.lat : bikeForm.location.coordinates[1]), lng: (!bikeForm.location.coordinates[0] ? gMap.startPlace.lng : bikeForm.location.coordinates[0]) }"
                                 ></GmapMarker>
                              </GmapMap>

                           </div>

                           <b-row class="mt-4">
                              <!-- Salvar  -->
                              <b-col v-if="this.bikeId" cols="12" md="3" class="text-center mb-3 mb-md-0">
                                 <el-button
                                    @click="getBikFormLocation('bikeForm.address', 'edit')"
                                    :loading="bikeFormStates.submit.loading"
                                    :round="true"
                                    type="primary"
                                    class="w-100 text-uppercase font-weight-bold">
                                    Salvar
                                 </el-button>
                              </b-col>

                              <!-- Editar fotos -->
                              <b-col v-if="this.bikeId" cols="12" md="4" class="text-center mb-3 mb-md-0">
                                 <el-button
                                    :loading="bikeFormStates.submit.loading"
                                    :round="true"
                                    type="blue"
                                    plain
                                    @click="() => this.goTo('fotos')"
                                    class="w-100 text-uppercase font-weight-bold">
                                    Editar Fotos →
                                 </el-button>
                              </b-col>

                              <!-- Próximo -->
                              <b-col v-if="!this.bikeId" cols="12" md="4" class="text-center mb-3 mb-md-0">
                                 <el-button
                                    @click="getBikFormLocation('bikeForm.address', 'register')"
                                    :loading="bikeFormStates.submit.loading"
                                    :round="true"
                                    type="primary"
                                    class="w-100 text-uppercase font-weight-bold">
                                    Próximo →
                                 </el-button>
                              </b-col>

                              <!-- Voltar -->
                              <b-col cols="12" md="3" class="text-center mb-3 mb-md-0">
                                 <el-button
                                    @click="goTo('caracteristicas')"
                                    type="default"
                                    :round="true"
                                    class="w-100 text-uppercase font-weight-bold">Voltar
                                 </el-button>
                              </b-col>

                              <b-col cols="12" md="2" class="text-center">
                                 <el-button
                                    @click="() =>  this.$router.push('/painel/anunciante/minhas-bicicletas')"
                                    type="default"
                                    :round="true"
                                    class="w-100 text-uppercase font-weight-bold">Sair
                                 </el-button>
                              </b-col>
                           </b-row>
                        </el-form>
                     </el-card>
                  </template>
               </transition>

               <!-- ====== ETAPA 5 - Fotos ====== -->
               <transition name="fade">

                  <template v-if="activeStepBike === 4">
                     <el-card class="transition-box box-card dashboard-card">
                        <div slot="header" class="clearfix">
                           <span>Fotos</span>
                        </div>
                        <el-form
                           v-loading="loading"
                           :model="bikeForm.photos"
                           :rules="bikeFormRules.photos"
                           ref="bikeForm.photos"
                           enctype="multipart/form-data"
                           method="post"
                           class="checkout-form dashboard-form pl-2 pr-2 bikeForm"
                           size="medium"
                        >

                           <el-row gutter="20">
                              <!-- Foto de Capa -->
                              <el-col :span="24" :lg="14">
                                 <h6>Foto de Capa</h6>
                                 <el-upload
                                    class="avatar-uploader bike-cover-photo mb-3"
                                    :class="{'photoError' : coverPhotoEmpty}"
                                    action=""
                                    ref="upload"
                                    :auto-upload="false"
                                    :show-file-list="false"
                                    :on-change="setObjCoverPhoto"
                                 >
                                    <!-- View photo via modal | Visualizar foto via modal -->
                                    <el-image
                                       v-if="photos.coverPhotoTempUrl"
                                       :src="photos.coverPhotoTempUrl"
                                       style="width: 100%; height: 300px"
                                       fit="cover"
                                       @click="fixRelativeBody"
                                    ></el-image>
                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>

                                 </el-upload>
                                 <el-alert
                                    v-show="coverPhotoEmpty"
                                    class="mb-4"
                                    title="ATENÇÃO: Você precisa enviar uma foto de capa."
                                    type="warning"
                                    :closable="false"
                                    show-icon
                                 >
                                 </el-alert>
                              </el-col>

                              <!-- Galeria de Fotos -->
                              <el-col :span="24" :lg="10">
                                 <h6>Galeria de Fotos</h6>

                                 <el-upload
                                    :file-list="fileList"
                                    :class="{limit : photos.maxFilesPhotoGallery}"
                                    class="bike-photo-gallery text-center text-md-left mb-3 mt-3 mt-md-0"
                                    :auto-upload="false"
                                    ref="upload"
                                    action="#"
                                    :limit="6"
                                    list-type="picture-card"
                                    :on-change="setObjPhotoGallery"
                                    :on-exceed="handleExceedItensGallery"
                                    :on-preview="thumbnailGalleryPreview"
                                    :on-remove="handleRemoveItensGallery"
                                 >
                                    <i class="el-icon-plus"></i>
                                 </el-upload>

                                 <!-- View photo via modal | Visualizar foto via modal -->
                                 <el-dialog :visible.sync="photos.dialogVisible">
                                    <img width="100%" :src="photos.dialogPhotoGalleryImageUrl"
                                         alt="">
                                 </el-dialog>

                              </el-col>

                              <!-- Informações sobre a foto ideal -->
                              <div class="alert-horizontal-photo">
                                 <el-alert
                                    :closable="false"
                                    title="Recomendamos fotos na horizontal. Use na vertical apenas para fotos dos detalhes do equipamento."
                                    type="info"
                                    effect="dark"
                                    show-icon
                                    class="mt-4 mt-lg-0">
                                 </el-alert>
                              </div>
                           </el-row>

                           <!-- Form Actions | Ações do formulário -->
                           <b-row>

                              <b-col cols="12" :xl="4" class="text-center mt-4">


                                 <!-- Atualizar Foto -->
                                 <el-form-item>
                                    <el-button
                                       @click="getBikFormPhotos('bikeForm.photos')"
                                       :loading="bikeFormStates.submit.loading"
                                       :round="true"
                                       type="blue"
                                       class="w-100 text-uppercase font-weight-bold">
                                       {{ this.bikeId ? 'Salvar Fotos' : 'Salvar Fotos e Publicar Bicicleta' }}
                                    </el-button>
                                 </el-form-item>

                              </b-col>

                              <!-- Voltar -->
                              <b-col v-if="this.bikeId" cols="12" xl="4" class="text-center mt-0 mt-xl-4">
                                 <el-form-item>
                                    <el-button
                                       @click=" goTo('local')"
                                       type="default"
                                       :round="true"
                                       class="w-100 text-uppercase font-weight-bold">
                                       Voltar
                                    </el-button>
                                 </el-form-item>
                              </b-col>

                              <!-- Voltar -->
                              <b-col v-if="!this.bikeId" cols="12" xl="4" class="text-center mt-0 mt-xl-4">
                                 <el-form-item>
                                    <el-button
                                       @onConfirm="cancelAndExitForm()"
                                       type="default"
                                       :round="true"
                                       class="w-100 text-uppercase font-weight-bold">Cancelar e Voltar
                                    </el-button>
                                 </el-form-item>
                              </b-col>

                              <b-col cols="12" md="3" class="text-center mt-0 mt-xl-4 mb-3 mb-md-0">
                                 <el-form-item>
                                    <el-button
                                       @click="() =>  this.$router.push('/painel/anunciante/minhas-bicicletas')"
                                       type="default"
                                       :round="true"
                                       class="w-100 text-uppercase font-weight-bold">Sair
                                    </el-button>
                                 </el-form-item>
                              </b-col>
                           </b-row>

                        </el-form>
                     </el-card>
                  </template>
               </transition>

            </b-col>
         </b-row>

      </b-container>
   </div>
</template>

<script>
import DashUserNav from "@/components/DashUserNav";
import {Money, VMoney} from 'v-money'
import numeral from 'numeral'
import bikeForm from '@/models/Bike';
import BikeService from '@/services/bike.service';
import SelectAvailableDatesCalendar from '@/components/SelectAvailableDatesCalendar';
import imageCompression from 'browser-image-compression';
import {setStatus, statusColor} from '@/helpers/status'
import imageRim from "@/assets/img/Pedale-Referencia-de-Aro-por-Idade.jpg"
import imageframeSize from "@/assets/img/tamanho-do-quadro.jpg"
import UserService from "@/services/user.service";
import {config} from "@/config"
import bikeBrands from "@/data/bikeBrands";
import {McWysiwyg} from '@mycure/vue-wysiwyg';

export default {
   name: 'NewBike',
   components: {
      DashUserNav,
      Money,
      SelectAvailableDatesCalendar,
      McWysiwyg
   },
   directives: {money: VMoney},
   data() {
      return {
         show: true,
         baseUrl: process.env.VUE_APP_BASE_URL,
         apiV1: process.env.VUE_APP_API_V1,
         dialogAvailableDates: true,
         titleCalendarCounter: false,
         availableDatesOk: false,
         placeEmpty: false,
         priceEmpty: false,
         rimDialog: false,
         frameSizeDialog: false,
         rate: () => this.isPJ ? config.pj.rates.serviceCostPercentage : config.pf.rates.serviceCostPercentage,
         rateDialog: false,
         netValue: 0.00,
         money: {
            decimal: ',',
            thousands: '.',
            prefix: 'R$ ',
            precision: 2,
            masked: false /* doesn't work with directive */
         },
         gMap: {
            options: {
               zoomControl: true,
               mapTypeControl: false,
               scaleControl: false,
               streetViewControl: false,
               rotateControl: false,
               fullscreenControl: false,
               disableDefaultUi: false
            },
            zoomMap: 3,
            coordinates: null,
            startPlace: {
               lat: -14.235004,
               lng: -51.92527999999999
            },
         },
         bikeTypeList: [
            {label: "Bike Adulto", value: "Bike Adulto"},
            {label: "Bike Infantil", value: "Bike Infantil"},
         ],
         bikeTypeData: {
            name: 'da Bicicleta',
            placeholder: 'Ex: Bicicleta aro 29 Legend 2017 24 Marchas',
         },
         bikeFeatureList: {
            rim: [
               {label: "Aro 12\"", value: "12"},
               {label: "Aro 16\"", value: "16"},
               {label: "Aro 20\"", value: "20"},
               {label: "Aro 24\"", value: "24"},
               {label: "Aro 26\"", value: "26"},
               {label: "Aro 27,5\"", value: "27,5"},
               {label: "Aro 29\"", value: "29"},
               {label: "Aro 700\"", value: "700"},
            ],
            suspension: [
               {label: "Nenhum", value: "Nenhum"},
               {label: "Dianteira", value: "Dianteira"},
               {label: "Traseira", value: "Traseira"},
               {label: "Dianteira e Traseira", value: "Dianteira e Traseira"},
            ],
            frameSize() {
               const boards = ["14","15", "16", "17", "18", "19", "20", "21", "22 E SPEED", "48", "50", "52", "54", "55", "56", "57", "58", "60", "62"];
               let item = [];
               boards.forEach((x) => {
                  item.push({label: x, value: x})
               });
               return item;
            },
            march(n) {
               let item = [];
               for (let i = 1; i <= n; i++) {
                  item.push({label: i, value: i});
               }
               return item
            },
            brand() {
               const brands = bikeBrands.sort();
               let item = [];
               brands.forEach((itens) => {
                  item.push({label: itens, value: itens});
               });
               return item;
            },
            maximumWeight: [
               {label: "100kg", value: "100"},
               {label: "120kg", value: "120"},
               {label: "150gk", value: "150"},
            ],
            indicatedFor: [
               {label: "Passeio", value: "Passeio"},
               {label: "Trilha", value: "Trilha"},
               {label: "Manobras Radicais", value: "Manobras Radicais"},
            ],
         },
         bikeForm,
         bikeFormRules: {
            info: {
               name: [
                  {required: true, message: 'Por favor, digite o nome da Bicicleta', trigger: 'blur'},
               ],
               bikeValue: [{required: true, validator: this.valueBikeValidation, trigger: 'blur'}],
               dailyValue: [
                  {required: false, validator: this.priceValidation, trigger: 'blur'}
               ],
               timeValue: [
                  {required: false, validator: this.priceValidation, trigger: 'blur'}
               ],
               weekValue: [
                  {required: false, validator: this.priceValidation, trigger: 'blur'}
               ],
               monthValue: [
                  {required: false, validator: this.priceValidation, trigger: 'blur'}
               ],
               description: [
                  {required: true, message: 'Digite a descrição', trigger: 'blur'},
               ],
            },
            features: {
               brand: [
                  {required: true, message: 'Selecione a marca', trigger: 'change'},
               ],
               rim: [
                  {required: true, message: 'Selecione o tipo de aro', trigger: 'change'},
               ],
               suspension: [
                  {required: true, message: 'Selecione o tipo de suspensão', trigger: 'change'},
               ],
               march: [
                  {required: true, message: 'Selecione a qtd. de marchas', trigger: 'change'},
               ],
            },
            address: {
               state: [
                  {required: true, message: 'Selecione o Estado', trigger: 'change'},
               ],
               city: [
                  {required: true, message: 'Selecione a cidade', trigger: 'change'},
               ],
               neighborhood: [
                  {required: true, message: 'Digite o Bairro', trigger: 'change'},
               ],
            }
         },
         bikeFormStates: {
            submit: {
               loading: false
            },
            cancel: {
               loading: false
            }
         },
         photos: {
            coverPhotoOk: false,
            coverPhotoTempUrl: '',
            maxFilesPhotoGallery: false,
            dialogPhotoGalleryImageUrl: '',
            dialogVisible: false,
            fileListTeste: {}
         },
         fileList: [],
         bikeId: null,
         localBikeId: null,
         coverPhotoEmpty: null,
         activeStepBike: 0,
         bikePhotosSaved: false,
         deletedPhotos: [],
         states: [],
         cities: [],
         loading: false,
         loadingCity: false,
         rentedDates: {
            orderInfo: [],
            dates: [],
         },
         rentedObjTemp: [],
         statusColor,
         setStatus,
         stopNextMonthSelection: false,
         helpModal: {
            open: false,
            title: '',
            desc: '',
            top: '15vh',
            width: '30%'
         },
         rimImg: `<img class="img-fluid" src="${imageRim}" alt="">`,
         frameSizeImg: `<img class="img-fluid" src="${imageframeSize}" alt="">`,
         user: {},
         userIsReady: false,
         userHasBankAccount: false,
         approvedDigitalAccount: false,
         updateCalendar: false,
         city: true,
         ufs: [],
         url: `/painel/anunciante/minhas-bicicletas/bicicleta/`
      }
   },

   async mounted() {

      if (!this.userData.data._id) await this.getUser();
      this.user = this.userData.data

      if (this.user) {
         this.approvedDigitalAccount = true
      }

      // if (!this.approvedDigitalAccount) {
      //    await this.$router.push('/painel/anunciante/minhas-bicicletas')
      // }

      this.bikeId = (this.$route.params.id ? this.$route.params.id : null);

      if (this.bikeId) {
         this.loading = true
      } else {
         this.resetForm('bikeForm.info');
         this.resetForm('bikeForm.features');
         this.resetForm('bikeForm.address');
      }

   },

   updated() {

      // Preenche a localização quando a aba é ativada.
      if (this.activeStepBike === 3 ) {
         let el = document.getElementById('inputPlace')
         if (el) {
            el.value = this.bikeForm.address.formatted_address;
         }
      }

   },

   methods: {

      async getUser() {
         await this.$store.dispatch('user/get', await UserService.getUserData())
      },

      enterKeyPlace() {
         if (this.bikeForm.location.coordinates.length === 0) {
            this.$message.warning('Por favor, selecione o local da lista');
            this.placeEmpty = true;
            this.bikeFormStates.submit.loading = false;
         }
      },

      getBikFormInfo(formName, isSave) {

         this.bikeFormStates.submit.loading = true;
         const values = this.bikeForm.info

         if (values.timeValue === 0 && values.dailyValue === 0 && values.weekValue === 0 && values.monthValue === 0) {
            this.$message.info('Por favor, preencha ao menos um valor, seja por hora, dia, semana ou mês');
            this.bikeFormStates.submit.loading = false;
            return false
         }

         this.$refs[formName].validate((valid) => {

            if (valid) {
               /*if (!this.bikeForm.info.availableDates.length) {
                  this.bikeFormStates.submit.loading = false;
                  this.availableDatesOk = true;
                  this.$message.error('Por favor, seleciona as datas de disponibilidade de locação!');
                  return false;
               }*/

               if (isSave) {
                  this.updateBikeData(true)
               } else {
                  this.goTo('disponibilidade')
               }

               this.bikeFormStates.submit.loading = false;

            } else {
               this.$message.warning('Por favor, preencha todos os campos corretamente!');
               this.bikeFormStates.submit.loading = false;
               return false;
            }
         });
      },

      getBikFormFeatures(formName, isSave) {

         this.bikeFormStates.submit.loading = true;

         this.$refs[formName].validate((valid) => {

            if (valid) {
               if (isSave) {
                  this.updateBikeData(true)
               } else {
                  this.goTo('local')
               }

               this.bikeFormStates.submit.loading = false;

            } else {
               this.$message.warning('Por favor, selecione as características da bike!');
               this.bikeFormStates.submit.loading = false;
               return false;
            }
         });


      },

      getBikFormLocation(formName, action) {

         this.bikeFormStates.submit.loading = true;

         this.$refs[formName].validate((valid) => {

            if (valid) {

               if (this.bikeForm.location.coordinates.length === 0) {
                  this.$message.warning('Por favor, selecione o local de retirada');
                  this.placeEmpty = true;
                  this.bikeFormStates.submit.loading = false;
                  return false;
               }

               if (action === 'edit') {
                  this.updateBikeData(true)
                  this.bikeFormStates.submit.loading = false;
               }

               if (action === 'register') {
                  this.sendBikeData();
                  this.bikeFormStates.submit.loading = false;
               }

               if (action === 'next') {
                  this.goTo('fotos')
                  this.bikeFormStates.submit.loading = false;
               }


            } else {
               this.$message.warning('Por favor, preencha os campos obrigatórios!');
               this.bikeFormStates.submit.loading = false;
               return false;
            }
         })
      },

      sendBikeData() {

         this.bikeFormStates.submit.loading = true;
         this.loading = true;
         /*delete this.bikeForm.coverPhoto;
             delete this.bikeForm.photoGallery;*/

         const info = this.bikeForm.info;
         const features = this.bikeForm.features;
         const address = this.bikeForm.address;
         const location = this.bikeForm.location;
         const state = this.bikeForm.address.state;
         const city = this.bikeForm.address.city;
         const neighborhood = this.bikeForm.address.neighborhood;

         const data = {
            ...info,
            features: {
               ...features
            },
            location,
            address: {
               ...address,
               state,
               city,
               neighborhood
            },
         };

         BikeService.addBike(data)
            .then((response) => {
               this.loading = false;
               this.bikeFormStates.submit.loading = false;
               this.$router.push(`/painel/anunciante/minhas-bicicletas/bicicleta/fotos/${response.data.data._id}`);
            })
            .catch(() => {
               this.goTo('local')
               this.loading = false;
               this.bikeFormStates.submit.loading = false;
            });
      },

      getBikFormPhotos() {

         this.bikeFormStates.submit.loading = true;

         if (!this.bikeForm.photos.coverPhoto) {
            this.coverPhotoEmpty = true;
            this.$message.warning('Por favor, selecione a foto de capa da bike!');
            this.bikeFormStates.submit.loading = false;
            return false;
         }

         this.sendBikePhotos(this.$route.params.id)

      },

      updateBikeData(isSaveEdit) {

         this.loading = true;
         this.bikeFormStates.submit.loading = true;

         const info = this.bikeForm.info;
         const features = this.bikeForm.features;
         const address = this.bikeForm.address;
         const location = this.bikeForm.location;
         const state = this.bikeForm.address.state;
         const city = this.bikeForm.address.city;
         const neighborhood = this.bikeForm.address.neighborhood;

         const data = {
            ...info,
            features: {
               ...features
            },
            location,
            address: {
               ...address,
               state,
               city,
               neighborhood
            }
         };

         BikeService.updateBike(this.bikeId, data)
            .then((response) => {

               this.$alert(response.data.message, 'Bike Atualizada!', {
                  confirmButtonText: 'OK',
                  cancelButtonText: 'Continuar editando',
                  closeOnClickModal: false,
                  showClose: false,
                  showCancelButton: true,
                  callback: (v) => {
                     this.loading = false;
                     if (v === 'confirm')
                        this.$router.push(`/painel/anunciante/minhas-bicicletas`);
                  }
               });

               setTimeout(() => {

                  if (!isSaveEdit) {
                     this.bikeFormStates.submit.loading = false;
                     this.goTo('fotos')
                  }

               }, 500)
            })
            .catch(() => {
               this.bikeFormStates.submit.loading = false;
               this.loading = false;
            });


      },

      sendBikePhotos(bikeId) {

         let gallery = this.bikeForm.photos.photoGallery;

         //Adiciona o cover a galeria no formData;
         let formData = new FormData();
         formData.append('cover', this.bikeForm.photos.coverPhoto);
         for (let key in gallery) {
            formData.append('gallery', gallery[key]);
         }

         if (this.deletedPhotos !== undefined) {
            formData.append('deletedPhotos', JSON.stringify(this.deletedPhotos));
         }
         this.$loading()
         BikeService.sendPhotos(bikeId, formData)
            .then((response) => {

               this.$alert(response.data.message, 'Sucesso!', {
                  confirmButtonText: 'OK',
                  closeOnClickModal: false,
                  showClose: false,
                  callback: () => {
                     this.bikeFormStates.submit.loading = false;
                     this.clearBikeForm();
                     Object.assign(this.$data, this.$options.data.apply(this));
                     this.$loading().close()
                     this.$router.push(`/painel/anunciante/minhas-bicicletas`);
                  }
               });

            })
            .catch(err => {
               const response = err.response.data;
               this.$message.error(`${response.message}`);
               this.bikeFormStates.submit.loading = false;
            });

      },

      /*
     *  Métodos para lidar a api de locais do google maps
     */
      updateCoordinates(location) {
         this.gMap.coordinates = true;

         const lng = location.latLng.lng();
         const lat = location.latLng.lat();

         this.bikeForm.location.coordinates = [];

         this.bikeForm.location.coordinates.push(lng);
         this.bikeForm.location.coordinates.push(lat);
      },

      // Algoritmo usado para formatar o endereço da bike com base na api do google places.
      formatPlace(address) {

         const check = [
            "country",
            "political",
            "route",
            "administrative_area_level_4",
            "administrative_area_level_3",
            "administrative_area_level_2",
            "administrative_area_level_1"
         ]
         return address
               .filter(f => f.types
                  .every(e => check
                     .includes(e)
                  ))
               .map(f => f.long_name)
               .join(', ')
      },

      setPlace(place) {
         if (place.geometry) {
            const address = this.formatPlace(place.address_components)
            this.bikeForm.address.formatted_address = place.formatted_address;
            this.bikeForm.address.name = address;

            this.gMap.zoomMap = 15;

            const lng = place.geometry.location.lng();
            const lat = place.geometry.location.lat();

            this.bikeForm.location.coordinates = [];

            this.bikeForm.location.coordinates.push(lng);
            this.bikeForm.location.coordinates.push(lat);
         }

      },

      clearPlace() {

         if (this.activeStepBike === 3) {
            let placeInput = document.getElementById('inputPlace');
            placeInput.value = null;
            this.gMap.coordinates = null;
            this.gMap.zoomMap = 3;
            this.bikeForm.location.coordinates = [];
         }

      },

      // ===== Métodos para lidar com as fotos ==== //
      setObjCoverPhoto(file) {

         if (this.photoIsOK(file)) {

            let imageFile = file.raw;

            let options = {
               maxSizeMB: 1,
               maxWidthOrHeight: 2000,
               useWebWorker: true,
               maxIteration: 10,
               onProgress: () => false
            };

            imageCompression(imageFile, options)
               .then((compressedFile) => {

                  this.photos.coverPhotoTempUrl = URL.createObjectURL(compressedFile);
                  this.bikeForm.photos.coverPhoto = compressedFile;
                  this.coverPhotoEmpty = false;
               })
               .catch(function (error) {
                  this.$message.error(`Ops, algo deu errado. Erro: ${error}`);
               });
         }
      },

      //Usado para resolver bug de overflow hidden ao clicar na imagem da capa.
      fixRelativeBody() {
         let body = document.querySelector("body");
         body.style.overflow = 'visible';
      },

      setObjPhotoGallery(file, fileList) {

         if (this.photoIsOK(file)) {

            let options = {
               maxSizeMB: 1,
               maxWidthOrHeight: 2000,
               useWebWorker: true,
               maxIteration: 10,
               onProgress: () => false
            };

            // Usado para ocultar o botão +
            this.photos.maxFilesPhotoGallery = fileList.length === 6;

            // Pega o objeto {raw: ...} do array
            let arrFiles = [];

            fileList.forEach((files) => {

               imageCompression(files.raw, options)
                  .then((compressedFile) => {

                     arrFiles.push(compressedFile)

                  })
                  .catch(function (error) {
                     this.$message.error(`Ops, algo deu errado. Erro: ${error}`);
                  });


            });

            // Adiciona os objetos na array photoGallery
            this.bikeForm.photos.photoGallery = arrFiles;

         } else {
            this.$refs.upload.uploadFiles.pop();
         }

      },

      handleRemoveItensGallery(file, fileList) {

         this.deletedPhotos.push(file.name);

         setTimeout(() => this.photos.maxFilesPhotoGallery = false, 1000);

         let arrFiles = [];

         fileList.forEach((file) => arrFiles.push(file.raw));

         this.bikeForm.photos.photoGallery = arrFiles;

      },

      thumbnailGalleryPreview(file) {

         this.photos.dialogPhotoGalleryImageUrl = file.url;
         this.photos.dialogVisible = true;

         /*  if (this.photoIsOK(file)) {
               this.photos.dialogPhotoGalleryImageUrl = file.url;
               this.photos.dialogVisible = true;
           }*/

      },

      handleExceedItensGallery() {
         this.$message.warning('São permitidos apenas 6 imagens para a galeria de fotos.');
      },

      photoIsOK(file) {

         const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'text/plain'];

         if (!allowedTypes.includes(file.raw.type)) {
            this.$message.error('ATENÇÃO: Somente imagens no formato JPEG, JPG e PNG.');
            return false;
         }

         const maxSize = file.raw.size > 20000000;

         if (maxSize) {
            this.$message.error('A foto não deve ser maior que 20mb.');
            return false
         }

         return true;
      },

      _r(d) {
         return d.replace(/-/g, '')
      },

      chackPlaceIsNotEmpaty(value) {
         this.placeEmpty = value.target.value === '';
      },

      valueBikeValidation(rule, value, callback) {

         let formatedPrice = numeral(value);

         if (formatedPrice._value < 0) {
            this.netValue = numeral(0.00).format('$ 0,0.00');
         }

         if (!formatedPrice._value || formatedPrice._value === 0.00) {
            return callback(new Error('Digite o valor'));
         }

         if (formatedPrice._value < 100) {
            return callback(new Error('Valor mínimo: R$ 100,00'));
         }

         if (formatedPrice._value > 100000) {
            return callback(new Error('Valor máximo: R$ 100.000,00'));
         }


         callback();

      },

      priceValidation(rule, value, callback) {

         if (value) {
            let formatedPrice = numeral(value);

            if (formatedPrice._value < 0) {
               this.netValue = numeral(0.00).format('$ 0,0.00');
            }

            if (rule.field === 'dailyValue' && formatedPrice._value < 1) {
               return callback(new Error('Valor mínimo: R$ 1,00'));
            }

            if (rule.field === 'dailyValue' && formatedPrice._value > 50000) {
               return callback(new Error('Valor máximo: R$ 50.000,00'));
            }
         }

         callback();

      },

      taxa(valor, taxa) {
         return valor * taxa / 100
      },

      setBikeUriCover(uri) {

         if (uri) {
            return `${process.env.VUE_APP_BASE_URL}/${uri.destination.replace(process.env.VUE_APP_DESTINATION_URL, '')}/${uri.filename}`
         }

      },

      setBikeUriGallery(uri) {

         if (uri) {
            let arrFiles = [];

            if (uri) {

               uri.forEach((item) => {
                  arrFiles.push(
                     {
                        originalname: item.originalname,
                        name: item.filename,
                        size: item.size,
                        type: item.mimetype,
                        url: `${process.env.VUE_APP_BASE_URL}/${item.destination.replace(process.env.VUE_APP_DESTINATION_URL, '')}/${item.filename}`
                     }
                  )
               });

            }

            this.fileList = arrFiles;
            this.photos.maxFilesPhotoGallery = this.fileList.length === 6;
         }

      },

      capitalize(str) {
         return str.replace(/(?:^|\s|["'([{])+\S/g, match => match.toUpperCase());
      },

      resetForm(formName) {
         this.$refs[formName].resetFields();
      },

      clearBikeForm() {
         this.bikeId = null;
         //this.resetForm('bikeForm.info');
         //this.resetForm('bikeForm.features');
         //this.resetForm('bikeForm.address');
         this.resetForm('bikeForm.photos')
         this.bikeForm.info.bikeType = "Bike Adulto"
         this.bikeForm.info.name = ""
         this.bikeForm.info.bikeValue = ""
         this.bikeForm.info.slug = ""
         this.bikeForm.info.timeValue = ""
         this.bikeForm.info.dailyValue = ""
         this.bikeForm.info.weekValue = ""
         this.bikeForm.info.monthValue = ""
         this.bikeForm.info.availableDates = []
         this.bikeForm.info.description = ""
         this.bikeForm.info.rating = {}
         this.bikeForm.info.rateMetrics = {
            averageRating: 0,
            totalRatings: 0
         }
         this.bikeForm.info.status = null
         this.bikeForm.info.user = null
         this.bikeForm.info.availableDates = []
         this.bikeForm.info.options = {
            isDisableSundays: false,
            isDisableSaturdays: false,
            isDisableDaysOfTheWeek: false,
            isDisableBrazilianHolidays: false
         }

         this.bikeForm.features.brand = ""
         this.bikeForm.features.rim = ""
         this.bikeForm.features.frameSize = ""
         this.bikeForm.features.suspension = ""
         this.bikeForm.features.march = ""
         this.bikeForm.features.observation = ""

         this.bikeForm.photos.photoGallery = null
         this.bikeForm.photos.coverPhoto = null

         this.bikeForm.location.coordinates = []

         this.bikeForm.address.formatted_address = ""
         this.bikeForm.address.name = ""
         this.bikeForm.address.state = ""
         this.bikeForm.address.city = ""
         this.bikeForm.address.neighborhood = ""

      },

      cancelAndExitForm() {


         this.$confirm('Tem certeza que deseja sair sem enviar as fotos? Caso saia, você poderá enviar as fotos depois ;)', 'Atenção', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancelar',
            type: 'warning'
         }).then(() => {
            this.clearBikeForm();
            this.$router.push('/painel/anunciante/minhas-bicicletas');
         }).catch(() => {
         });

      },

      goTo(step) {
         this.$router.push(`${this.url}${step}${this.bikeId ? `/${this.bikeId}` : ''}`);
      },

      exit() {
         this.$confirm('Tem certeza de que deseja sair desta página sem salvar?', 'Atenção', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancelar',
            type: 'warning'
         }).then(() => {
            this.$router.push('/painel/anunciante/minhas-bicicletas')
         }).catch(() => {
         });
      },

      // Atualiza as opções de atalho do calendário
      handleGetDataCalendar(data) {
         const { key, state } = data
         const actualOptions = this.bikeForm.info.options
         this.bikeForm.info.options = {...actualOptions, [key]: state}
      }

   },
   computed: {
      currentUser() {
         return this.$store.state.auth.user;
      },
      userData() {
         return this.$store.state.user
      },
      isPJ() {
         return this.$store.state.user.data.additionalInformation.type === 'pj' || false
      },
   },
   watch: {
      'bikeForm.info.type': function (n) {
         switch (n) {
            case 'Carrinho':
               this.bikeTypeData.name = 'do Carrinho';
               this.bikeTypeData.placeholder = 'Ex: Carrinho Coupe Polícia com Volante';
               break;
            case 'Motoca':
               this.bikeTypeData.name = 'da Motoca';
               this.bikeTypeData.placeholder = 'Ex: Triciclo de Passeio com Acento Almofadado';
               break;
            default:
               this.bikeTypeData.name = 'da Bicicleta';
               this.bikeTypeData.placeholder = 'Ex: Bicicleta aro 29 Legend 2017 24 Marchas';
         }
      },
      bikeId: function (n) {
         if (n) {
            BikeService.getBikeById(n).then(
               response => {

                  const data = response.data.data;

                  //Verifica se há datas reservadas
                  if (data.rented) {
                     //Caso tenha, cria lista de datas, com base na data início e data fim.
                     data.rented.map((v, index) => {
                        let checkin = this.$moment(v.period.checkin);
                        let checkout = v.period.checkout;
                        let tempArr = []

                        this.rentedDates.orderInfo.push(v);
                        //this.rentedDates.orderInfo.rentedDatesList = [];

                        while (!this.$moment(checkin).isSame(this.$moment(checkout).add(1, 'days'))) {
                           checkin = this.$moment(checkin).add(1, 'days')
                           this.rentedDates.dates.push(checkin.format("YYYY-MM-DD"))
                           tempArr.push(checkin.format("YYYY-MM-DD"))
                        }
                        this.rentedDates.orderInfo[index].rentedDatesList = tempArr;

                     })
                     this.rentedDates.dates.sort();

                  }

                  this.bikeForm = {
                     info: {
                        bikeType: data.bikeType,
                        name: data.name,
                        bikeValue: data.bikeValue,
                        timeValue: data.timeValue,
                        dailyValue: data.dailyValue,
                        weekValue: data.weekValue,
                        monthValue: data.monthValue,
                        availableDates: data.availableDates,
                        description: data.description,
                        options: data.options,
                     },
                     features: data.features,
                     location: {
                        coordinates: data.location.coordinates,
                     },
                     address: data.address,
                     photos: {
                        coverPhoto: (data.coverPhoto ? data.coverPhoto : null),
                        photoGallery: (data.photoGallery ? data.photoGallery : null)
                     },
                  };

                  this.gMap.zoomMap = 15;

                  this.photos.coverPhotoTempUrl = this.setBikeUriCover(this.bikeForm.photos.coverPhoto);

                  this.photos.coverPhotoTempUrl = this.setBikeUriCover(response.data.data.coverPhoto);

                  this.setBikeUriGallery(response.data.data.photoGallery);

                  this.setBikeUriGallery(this.bikeForm.photos.photoGallery);
                  this.loading = false;
               },
               err => {
                  // this.$message.error(err.response.data.message);
                  if (err.response.data.error === 'bicycleNotFound' ||
                     err.response.data.error === 'invalidId' ||
                     err.response.status === 404
                  ) {
                     this.$router.push('/painel/anunciante/minhas-bicicletas')
                  }
                  this.loading = false;
               }
            );
         }
      },
      '$route': {
         handler: function (page) {
            switch (page.params.step) {
               case 'info':
                  this.activeStepBike = 0;
                  break
               case 'disponibilidade':
                  this.activeStepBike = 1;
                  break
               case 'caracteristicas':
                  this.activeStepBike = 2;
                  break
               case 'local':
                  this.activeStepBike = 3;
                  break
               case 'fotos':
                  this.activeStepBike = 4;
                  break
               default:
                  this.activeStepBike = 0;
            }
         },
         deep: true,
         immediate: true
      }
   },
};
</script>

<style>

@media screen and (max-width: 992px) {
   .dica-local .el-form-item__label {
      line-height: 18px !important;
   }
}

.el-form-item__label {
   text-align: left;
}

button.wysiwyg-button {
   border: 0;
}

.editor {
   .label {
      color: #47b54c;
      font-size: 14px;
      margin-bottom: 5px;
   }
   #container {
      border-radius: 5px
   }
   #toolbar {
      border-radius: 5px 5px 0 0;
   }
}
.transition-box {
   position: absolute;
   width: 100%;
}
.avatar-uploader .el-upload {
   border: 1px dashed #d9d9d9;
   border-radius: 6px;
   cursor: pointer;
   position: relative;
   overflow: hidden;
}

.avatar-uploader .el-upload:hover {
   border-color: #409EFF;
}

.avatar-uploader-icon {
   font-size: 28px;
   color: #8c939d;
   width: 178px;
   height: 178px;
   line-height: 178px;
   text-align: center;
}

.v-select .vs__dropdown-menu {
   max-height: 300px; /* Define a altura máxima */
   overflow-y: auto;  /* Adiciona barra de rolagem quando necessário */
}

.vs__dropdown-toggle {
   border: 1px solid #DCDFE6;
}


@media screen and (max-width: 768px) {
   .vs__dropdown-toggle, .v-select ul {
      font-size: 1rem;
   }

}

@media screen and (min-width: 768px) {
   .vs__selected-options {
      padding: 2px 2px 3px 2px;
   }
}

.alert-horizontal-photo {
   .el-alert__title {
      font-size: 1rem;
   }
}


.avatar {
   width: 178px;
   height: 178px;
   display: block;
}
</style>
